import React from "react";
import * as actions from './Actions';
import Service from '../../service/Service';
const service = new Service();

export default function ReadSection ({readData, eleRef}){
    // var eleRef = readData.eleRef;
    // var readData = readData.readData;
    return(
        <section className="read-section">
            <div className="section-title">READ</div>
            {readData.article.map((article, i1) => 
            <div key={i1} className="read-article">
                <div className="article-img left">
                    <a href={article.articleUrl}>
                    <img src={article.articleImage.replace("http://", "https://")} className="dev_rd_img" onError={(e) => {e.target.src = 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-placeholder.png'}}/>
                    </a>
                </div>
                <div className="article-info left">
                    <div className="arti-title M14_42">
                        <a href={article.articleUrl} className="dev_rd_title">{article.articleTitle}</a>
                    </div>
                    <div className="arti-date R13_9e">{
                        article.createdDatetime &&
                    actions.getDate(article.createdDatetime)}</div>
                </div>
            </div>
            )}
            
            {readData.search_cnt > readData.article.length &&
            <div className="moreResults dev_v_all" title="READ" onClick={()=>eleRef.getMoreSearchData(readData.type)}>SEE MORE RESULTS</div>
            }
        </section>
    );
}
